var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.00033L5.5 7.00033M15.5 2.00033L5.5 2.00033M15.5 12.0003L5.5 12.0003M2.16667 7.00033C2.16667 7.46056 1.79357 7.83366 1.33333 7.83366C0.873096 7.83366 0.5 7.46056 0.5 7.00033C0.5 6.54009 0.873096 6.16699 1.33333 6.16699C1.79357 6.16699 2.16667 6.54009 2.16667 7.00033ZM2.16667 2.00033C2.16667 2.46056 1.79357 2.83366 1.33333 2.83366C0.873096 2.83366 0.5 2.46056 0.5 2.00033C0.5 1.54009 0.873096 1.16699 1.33333 1.16699C1.79357 1.16699 2.16667 1.54009 2.16667 2.00033ZM2.16667 12.0003C2.16667 12.4606 1.79357 12.8337 1.33333 12.8337C0.873096 12.8337 0.5 12.4606 0.5 12.0003C0.5 11.5401 0.873096 11.167 1.33333 11.167C1.79357 11.167 2.16667 11.5401 2.16667 12.0003Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListviewIcon);
export default __webpack_public_path__ + "static/media/listview_Icon.37df12500308bf53d1114c1c8ef943d3.svg";
export { ForwardRef as ReactComponent };